import React from 'react';
import BlogFAQSection from '../blog/BlogFAQSection';
import StructuredDataFAQ from '@/components/seo/StructuredDataFAQ';
import { finanzcoachingFAQData } from '@/data/faq/finanzcoaching-faq';

const FinanzcoachingFAQ = () => {
  const faqItems = finanzcoachingFAQData;

  return (
    <section id="faq" className="section-spacing bg-white">
      <StructuredDataFAQ faqItems={faqItems} pageName="Finanzcoaching" />
      <div className="container max-w-4xl">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Häufige Fragen
          </span>
          <h2 className="animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Finanzcoaching verstehen
          </h2>
          <p className="text-joerg-600 text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Wichtige Antworten zur persönlichen Entwicklung im Umgang mit Geld und finanzieller Selbstbestimmung.
          </p>
        </div>
        
        <BlogFAQSection 
          items={faqItems} 
          title="" 
        />
      </div>
    </section>
  );
};

export default FinanzcoachingFAQ;